import styles from "./styles.module.scss";

export const DownloadButtons = ({
  downloadBtns,
  handleDownloadJsonUrl,
  fileid,
}) => {
  return (
    <div className={styles.downloadBtnsContainer}>
      {downloadBtns.map((clickedBtnData) => {
        const BtnIcon = clickedBtnData.icon;
        return (
          <div
            key={clickedBtnData?.key}
            className={styles.btnContainer}
            title={clickedBtnData.title}
            onClick={() =>
              handleDownloadJsonUrl({
                clickedBtnData,
                fileid,
              })
            }
          >
            <BtnIcon />
          </div>
        );
      })}
    </div>
  );
};
